module.exports = __webpack_public_path__ + "img/no-activities.640ee0e8.svg";